import { SEO } from "components/core/seo"
import { NextPage } from "next"
import React, { useEffect } from "react"
import { Spinner } from "components/core/spinner"
import { useRouter } from "next/router"
import { useUser } from "lib/supabase/auth"
import { Grid } from "components/dashboard/grid/grid"
import { useSelectDashboards } from "reactQuery/dashboard"
import { InitialDashboard } from "components/dashboard/initialDashboard"
import { BASE_URL, getDashboardSlug } from "lib/utils"

const DefaultDashboardPage: NextPage = () => {
  const { user } = useUser()
  const { replace } = useRouter()
  const { data: dashboards } = useSelectDashboards()
  const primaryDashboard = dashboards?.find((d) => d.is_primary)
  const seo = (
    <SEO
      title="Dashboard"
      description="Frontend Toolkit offers customizable dashboards for your recurring Frontend tasks. Base64 encoder/decoder, SVG optimizations, SVG to JSX and many more!"
      ogImage={{
        title: "Your own dashboard",
        url: `${BASE_URL}/dashboard`,
      }}
    />
  )

  useEffect(() => {
    if (primaryDashboard?.id && user) {
      replace("/dashboard/[slug]", `/dashboard/${getDashboardSlug(primaryDashboard.id, user.id)}`)
    }
  }, [primaryDashboard, replace, user])

  if (!primaryDashboard) {
    return (
      <>
        {seo}
        <InitialDashboard />
      </>
    )
  }

  return (
    <>
      {seo}
      {!user && primaryDashboard ? (
        <Grid dashboard={primaryDashboard} />
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <Spinner className="w-10 h-10 text-indigo-600 dark:text-indigo-400" />
        </div>
      )}
    </>
  )
}

export default DefaultDashboardPage
